export default __webpack_public_path__ + "static/media/Route.e28d9ec6.svg";